import React from "react";
//import I18n from "i18n-js/index.js.erb"

class PaceSelect extends React.Component {
  constructor(props) {
    super(props);
    this.processPaceSelector = this.processPaceSelector.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.pace_selector === null && prevProps.pace_selector != null) {
      $(this.refs.pace_selectors).val("").trigger("change");
    }
  }

  componentDidMount() {
    var self = this;

    if (this.refs.pace_selectors) {
      $(this.refs.pace_selectors)
        .select2({
          data: [
            {
              id: 1,
              text: `very_behind_pace`,
              percentage: "-(67%-100%)",
              color: "#A00000",
              selected:
                this.props.pace_selector === "very_behind_pace" ? true : false,
            },
            {
              id: 2,
              text: `behind_pace`,
              percentage: "-(34%-66%)",
              color: "#FF5000",
              selected:
                this.props.pace_selector === "behind_pace" ? true : false,
            },
            {
              id: 3,
              text: `slightly_behind_pace`,
              percentage: "-(1%-33%)",
              color: "#FF9000",
              selected:
                this.props.pace_selector === "slightly_behind_pace"
                  ? true
                  : false,
            },
            {
              id: 4,
              text: `on_pace`,
              percentage: "(0%)",
              color: "#FFE102",
              selected: this.props.pace_selector === "on_pace" ? true : false,
            },
            {
              id: 5,
              text: `slightly_ahead_of_pace`,
              percentage: "+(1%-33%)",

              color: "#33CC33",
              selected:
                this.props.pace_selector === "slightly_ahead_of_pace"
                  ? true
                  : false,
            },
            {
              id: 6,
              text: `ahead_of_pace`,
              percentage: "+(34%-66%)",
              color: "#339933",
              selected:
                this.props.pace_selector === "ahead_of_pace" ? true : false,
            },
            {
              id: 7,
              text: `very_ahead_of_pace`,
              percentage: "+(67%-100%)",
              color: "#336633",
              selected:
                this.props.pace_selector === "very_ahead_of_pace"
                  ? true
                  : false,
            },
          ],
          allowClear: true,
          minimumResultsForSearch: Infinity,

          placeholder: I18n.t("select_ellipsis"),
          templateResult: function (pace_selector) {
            return self.processPaceSelector(pace_selector);
          },
          templateSelection: function (pace_selector) {
            if (
              pace_selector &&
              pace_selector.id != null &&
              pace_selector.id != ""
            ) {
              self.props.onChange(pace_selector);

              return self.processPaceSelector(pace_selector);
            } else {
              return pace_selector.text;
            }
          },
        })
        .on("select2:unselect", function () {
          self.props.onChange(null);
        })
        .on("select2:select", function (selection) {
          self.props.onChange(selection.params.data);
        });
    }
  }

  render() {
    return (
      <select
        className="form-control"
        ref="pace_selectors"
        style={{ width: "100%", minHeight: 33 }}
      >
        <option></option>
      </select>
    );
  }

  processPaceSelector(pace_selector) {
    var $state = $(
      `<span><div style="
        width: 20px;
        height: 20px;
        display: inline-block;
        background-color: ${pace_selector.color};
        position: relative;
        top: 5px;"
        ></div>&nbsp &nbsp${`${I18n.t(pace_selector.text)} ${
          pace_selector.percentage
        }`}<span></span></span>`
    );
    return $state;
  }
}

export default PaceSelect;
